import {
  take,
  takeEvery,
  put,
  select,
  fork,
  cancel,
  cancelled,
  spawn,
} from "redux-saga/effects";

import {
  SYS_NAME,
  START,
  STARTED,
  STOP,
  STOPPED,
  TOGGLE_OKTELL_SYNC,
  START_LISTEN_FOR_CALLS,
  STOP_LISTEN_FOR_CALLS,
  NEW_CALL_DETECTED,
  CREATE_SUPPORT_TICKET,
  OKTELL_WS_CLOSED,
} from "../CONSTANTS";

import localSelectors from "../selectors/local";

import oktell from "./oktell/saga";
import handleIncomingCall from "./oktell/handleIncomingCall";
import createSDRequest from "./service-desk/createRequest";

export function* handle(config, action) {
  const { storePath } = config;
  switch (action.type) {
    case CREATE_SUPPORT_TICKET: {
      yield spawn(createSDRequest, { action, config });
      break;
    }
    case TOGGLE_OKTELL_SYNC: {
      const oktellSync = yield select(
        localSelectors.oktellSync,
        null,
        storePath
      );
      if (oktellSync) {
        yield put({ type: STOP_LISTEN_FOR_CALLS });
      } else {
        yield put({ type: START_LISTEN_FOR_CALLS });
      }
      break;
    }
    case NEW_CALL_DETECTED: {
      yield spawn(handleIncomingCall, { action, config });
      break;
    }
    case OKTELL_WS_CLOSED: {
      if (action.reopen) {
        yield put({ type: START_LISTEN_FOR_CALLS });
      }
      break;
    }
  }
}

export function* watch(config) {
  yield put({ type: STARTED });
  try {
    yield takeEvery(
      (action) => action.type.startsWith(`${SYS_NAME}:`),
      handle,
      config
      // action is always passed to handle function as last parameter
    );
  } finally {
    if (yield cancelled()) {
      yield put({ type: STOPPED });
    }
  }
}

export default function* init(config = {}) {
  const conf = {
    storeShape: config.storeShape,
    storePath: config.storePath || ["clients"],
    ...config,
  };
  while (yield take(START)) {
    const oktellWatcher = yield fork(oktell, conf);
    const watcher = yield fork(watch, conf);
    yield take(STOP);
    yield cancel(watcher);
    yield cancel(oktellWatcher);
  }
}



// WEBPACK FOOTER //
// ./src/model/subsystems/clients/saga/saga.js